// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


// 时间
import moment from "moment"

import VueClipboard from "vue-clipboard2";
import JsonViewer from 'vue-json-viewer'

import Axios from "axios"
import api from './utils/http/index'


import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

Vue.use(api)
Vue.prototype.$axios = Axios

Vue.prototype.$moment = moment;
Vue.use(VueClipboard)
Vue.use(JsonViewer)


Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
